import moment from 'moment-timezone';

export const getHoursAndMinutesFromDate = (date) => {
  return moment(date).format('HH:mm');
};

export const getFormattedDateFromDate = (date) => {
  return moment(date).format('dddd D MMMM');
};

export const getLabelForRange = (from, to) => {
  const labelFrom = getHoursAndMinutesFromDate(from);
  const labelTo = getHoursAndMinutesFromDate(to);
  return {
    labelFrom,
    labelTo,
  };
};

export const getAvailableTimeRanges = ({
  minTime,
  windowTimeInHours,
  itemIncrementInMinutes,
}) => {
  const items = [];

  let nextItemFrom = moment(minTime).toJSON();
  let nextItemTo = moment(minTime).add(windowTimeInHours, 'hours').toJSON();
  let nextItemLabel = getLabelForRange(nextItemFrom, nextItemTo);
  let currentItem = {
    from: nextItemFrom,
    to: nextItemTo,
    label: nextItemLabel,
  };
  items.push(currentItem);

  let keepAdding = true;

  while (keepAdding) {
    nextItemFrom = moment(currentItem.from)
      .add(itemIncrementInMinutes, 'minutes')
      .toJSON();
    nextItemTo = moment(currentItem.to)
      .add(itemIncrementInMinutes, 'minutes')
      .toJSON();
    nextItemLabel = getLabelForRange(nextItemFrom, nextItemTo);

    const isSameDay = moment(nextItemTo).isSame(moment(minTime), 'day');
    if (isSameDay) {
      currentItem = {
        from: nextItemFrom,
        to: nextItemTo,
        label: nextItemLabel,
      };
      items.push(currentItem);
    } else {
      keepAdding = false;
    }
  }
  return items;
};

export const getLabelForTime = (time) => {
  const label = getHoursAndMinutesFromDate(time);
  return label;
};

export const getAvailableTimes = ({
  minTime,
  maxTime,
  itemIncrementInMinutes,
}) => {
  const items = [];

  let nextItemTime = moment(minTime).toJSON();
  let nextItemLabel = getLabelForTime(nextItemTime);
  let currentItem = {
    time: nextItemTime,
    label: nextItemLabel,
  };
  items.push(currentItem);

  let keepAdding = true;
  let separatorAdded = false;

  while (keepAdding) {
    nextItemTime = moment(currentItem.time)
      .add(itemIncrementInMinutes, 'minutes')
      .toJSON();
    nextItemLabel = getLabelForTime(nextItemTime);

    const isBeforeMaxTime = moment(nextItemTime).isSameOrBefore(
      moment(maxTime)
    );
    if (isBeforeMaxTime) {
      if (!separatorAdded) {
        const isSameDay = moment(nextItemTime).isSame(minTime, 'day');
        if (!isSameDay) {
          items.push({
            isDaySeparator: true,
          });
          separatorAdded = true;
        }
      }
      currentItem = {
        time: nextItemTime,
        label: nextItemLabel,
      };
      items.push(currentItem);
    } else {
      keepAdding = false;
    }
  }
  return items;
};
